// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ec6bedf2","239":"6506e7cf","453":"1e7ecbe5","455":"1519b41e"}[chunkId] + ".chunk.js";
};